export default "declare module 'stats' {\n    export function getMaxIndex(input: unknown, comparator: unknown): unknown;\n}\n";